module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"main":"Zugang","settings":"Einstellungen","rksv":"RKSV","password":"Passwort","sessions":"Sitzungen","login":"Anmelden","logout":"Abmelden","register":"Registrierung"},"en":{"main":"Account","settings":"Settings","rksv":"RKSV","password":"Password","sessions":"Sessions","login":"Sign in","logout":"Sign out","register":"Register"}}')
  delete Component.options._Ctor
}
